import { render, staticRenderFns } from "./OrganizationSpecialists.vue?vue&type=template&id=be6a18b0&scoped=true&"
import script from "./OrganizationSpecialists.vue?vue&type=script&lang=js&"
export * from "./OrganizationSpecialists.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSpecialists.vue?vue&type=style&index=0&id=be6a18b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a18b0",
  null
  
)

export default component.exports